import http from '@root/utils/axios/admin';

let state = {
    AdvertisementsList: [],
    Advertisement: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchAdvertisementsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/advertisements', { params: filter }).then((response) => {
                commit('setAdvertisements', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteAdvertisement({ commit }, id) {
        return http.delete('/api/advertisements/' + id);
    },

    fetchAdvertisement({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/advertisements/' + id).then((response) => {
                commit('setAdvertisement', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateAdvertisement({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/advertisements', data).then((response) => {
                commit('setAdvertisement', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setAdvertisementError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateAdvertisement({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/advertisements/' + data.get('id'), data).then((response) => {
                commit('setAdvertisement', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setAdvertisementError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setAdvertisements(state, data) {
        state.AdvertisementsList = data;
    },
    setAdvertisement(state, data) {
        state.Advertisement.data = data;
    },
    setAdvertisementError(state, error) {

        state.Advertisement.error = error.errors;
    },
    cleanAdvertisementError(state, error) {
        state.Advertisement.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}